// Event Calendar Helper Functions and Utilities

export const getEventTypeColor = (type) => {
  switch(type) {
    case 'club-show': return '#9D4EDD';
    case 'festival': return '#FFD700';
    case 'festival_attendance': return '#FFD700';  // Gold for "I'm Going" festival events
    case 'livestream': return '#FF006E';
    case 'private-event': return '#3A86FF';
    case 'demo_deadline': return '#FF4444';  // Red for demo deadlines
    case 'contest_deadline': return '#9D4EDD';  // Purple for contest deadlines
    default: return '#00ffff';
  }
};

export const getEventTypeIcon = (type) => {
  switch(type) {
    case 'club-show': return '🎵';
    case 'festival': return '🎪';
    case 'festival_attendance': return '🎫';  // Ticket emoji for "I'm Going" events
    case 'livestream': return '📡';
    case 'private-event': return '🎉';
    case 'demo_deadline': return '📧';  // Envelope for demo deadlines
    case 'contest_deadline': return '🏆';  // Trophy for contest deadlines
    default: return '🎵';
  }
};

export const getMonthName = (date) => {
  return date.toLocaleString('default', { month: 'long', year: 'numeric' });
};

export const getDaysInMonth = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth();
  return new Date(year, month + 1, 0).getDate();
};

export const getFirstDayOfMonth = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth();
  return new Date(year, month, 1).getDay();
};

export const getEventsForDate = (events, day, currentDate) => {
  return events.filter(event => {
    const eventDate = new Date(event.event_date);
    return eventDate.getDate() === day &&
           eventDate.getMonth() === currentDate.getMonth() &&
           eventDate.getFullYear() === currentDate.getFullYear();
  });
};
